import { render, staticRenderFns } from "./aliPay.vue?vue&type=template&id=9714bcec&scoped=true&"
import script from "./aliPay.vue?vue&type=script&lang=js&"
export * from "./aliPay.vue?vue&type=script&lang=js&"
import style0 from "./aliPay.vue?vue&type=style&index=0&id=9714bcec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9714bcec",
  null
  
)

export default component.exports